import React, {ReactElement} from 'react';
import {useTranslation} from 'react-i18next';
import NumberInput from '../../../../ui/components/NumberInput';
import FontAndBackgroundColorPicker, {COLOR_FIELDS} from '../common/fontAndBackgroundColorPicker';
import SlideChange from '../common/slideChange';
import {TABS} from '../../form/part/tabs';
import AnimationForm from '../common/animationForm';
import {IElementLineV2} from '../../../../incase-domain/elements/shapes/lineV2';
import {IElementArrowV2} from '../../../../incase-domain/elements/shapes/arrowV2';
import {useHighlightedElement, useSetHighlightedElement} from '../../../../utils/hooks/slideUpdates/useSetSlideElement';

interface HighlightedLineElementComponentV2Props {
    activeTab: string;
}
function HighlightedLineElementComponentV2(props: HighlightedLineElementComponentV2Props): ReactElement {
    const {activeTab} = props;
    const {t} = useTranslation();
    const highlightedElement = useHighlightedElement() as IElementLineV2 | IElementArrowV2;
    const updateHighlightedElement = useSetHighlightedElement();

    if (activeTab === TABS.STYLE.id) {
        return (
            <>
                <div className="l-group--form">
                    <div className="l-group__item u-flex u-flex-col u-gap-2">
                        <NumberInput
                            label={t('designSidepanel.lineThickness')}
                            step={0.1}
                            min={0.1}
                            value={highlightedElement.size || 0.1}
                            onChange={(newValue) => {
                                updateHighlightedElement.single('size', newValue || 1);
                            }}
                        />
                        <FontAndBackgroundColorPicker
                            highlightedElement={highlightedElement}
                            highlightedElementChangeHandler={updateHighlightedElement}
                            colorFields={[COLOR_FIELDS.BACKGROUND_COLOR]}
                            placeholder={t('designSidepanel.lineColor')}
                        />
                    </div>
                </div>
            </>
        );
    }

    return (
        <>
            <AnimationForm
                appearAfter={highlightedElement.appearAfter || 0}
                elementAnimations={highlightedElement.elementAnimations}
                highlightedElementChangeHandler={updateHighlightedElement}
            />
            <div className="l-group--form">
                <SlideChange
                    slideChange={highlightedElement.slideChange}
                    setSlideChange={(slideChange) => {
                        updateHighlightedElement.single('slideChange', slideChange);
                    }}
                />
            </div>
        </>
    );
}

export default HighlightedLineElementComponentV2;
